import apiClient from "./client";

export async function fetchTopHeaderLinks(signal) {
  const response = await apiClient.get("site/top-header-links/", { signal });
  return response.data;
}

export async function fetchPublicFAQ(signal) {
  const response = await apiClient.get("site/faq/", { signal });
  return response.data;
}
